import type { IntlShape } from "@formatjs/intl";
import { Card, Col, Flex, Form, Input, Row, Select } from "antd";
import { countries } from "../../common/constants/enums.ts";

const countryOptions = Object.entries(countries).map(([code, name]) => ({
  value: code,
  label: name,
}));

type LocationFieldsProps = {
  intl: IntlShape;
};

export const LocationFields = ({ intl }: LocationFieldsProps) => (
  <Flex vertical gap="middle">
    <Card title={intl.formatMessage({ id: "location_section_details" })}>
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label={intl.formatMessage({ id: "location_name" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "validation_message_location_name" }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="country"
            label={intl.formatMessage({ id: "location_country" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "validation_message_location_country",
                }),
              },
            ]}
          >
            <Select
              showSearch
              allowClear
              optionFilterProp="label"
              options={countryOptions}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name="description"
            label={intl.formatMessage({ id: "location_description" })}
          >
            <Input.TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  </Flex>
);
